import React from "react";

import PricingPageV1 from "../../component/pages/PricingPage";
import PricingPageV2 from "../../V2/components/pages/PricingPage";

function Pricing() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber" 
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";

  if (isV2) {
    return (
      <PricingPageV2 />
    )
  }

  return (
    <PricingPageV1 />
  );
}

export default Pricing;
